

import { useAgent } from "@/hooks/useAgent"
import {
    putOrder,
    createOrder,
} from "@/api/goods";

import { useRoute, useRouter } from 'vue-router'
import { reactive } from "vue"
import { Toast } from "vant"
export const useCreateOrder = () => {
    const { md, ua, network, os, isWeChat } = useAgent();
    const router = useRouter()
    const route = useRoute()
    const state = reactive({
        couponInfo: {},
        goodsInfo: {},
        options: [],
    })
    // 创建新订单
    async function createNewOrder() {
        const { guid } = state.goodsInfo;
        const { width, height } = window.screen;
        const data = {
            phone_model: "",
            browser_version: ua,
            screen_resolution: `${width}*${height}`,
            network,
            use_env: isWeChat ? 1 : 2,
            ...route.query,
        };

        if (os == "iOS") {
            //ios系统的处理
            data.phone_model = md.os() + md.version("iPhone");
        } else if (os == "AndroidOS") {
            //Android系统的处理
            data.phone_model = md.os() + md.version("Android");
        }
        try {
            // 下单
            const {
                data: { out_trade_no },
            } = await putOrder({

                ...data,
                guid,
            });
            // 创建试卷订单
            const {
                data: { paper_order_sn },
            } = await createOrder({
                out_trade_no,
            });
            goExam({
                paper_order_sn,
                guid,
            });
        } catch (error) {
            Toast("网络异常，请重试");
            console.log(error);
        }
    }

    // 跳转做题页
    function goExam({
        paper_order_sn, guid, }) {
        // 浏览器环境下将优惠券编码传递过去
        const query = !isWeChat ? {
            coupon_code: state.couponInfo.code
        } : {}
        router.push({
            path: "/exam",
            query: {
                paper_order_sn,
                guid,
                ...query
            },
        });
    }
    // 跳转版本选择
    const goChooseGeneral = () => {
        const { guid } = state.goodsInfo;
        localStorage.setItem(
            "goodsChooseGen",
            JSON.stringify({
                options: JSON.stringify(state.options),
                guid,
                goodsInfo: state.goodsInfo,
                versionText: state.goodsInfo.versionText,
            })
        );
        // 浏览器环境下将优惠券编码传递过去
        const query = !isWeChat ? {
            coupon_code: state.couponInfo.code
        } : {}
        router.push({
            path: "/chooseGender",
            query
        });
    };



    function getVersionInfo() {

        const {
            left_version_text,
            right_version_text,
            left_version_image,
            right_version_image,
        } = state.goodsInfo;
        state.options = [
            {
                id: 1,
                name: left_version_text,
                img: left_version_image,
            },
            {
                id: 2,
                name: right_version_text,
                img: right_version_image,
            },
        ];
    }

    async function createExamOrder({ couponInfo, goodsInfo }) {
        state.couponInfo = couponInfo
        state.goodsInfo = goodsInfo

        if (state.goodsInfo.goods_version === 2) {
            getVersionInfo()
            goChooseGeneral()
        } else {
            createNewOrder()
        }
    }

    return {
        createExamOrder
    }
}